var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCooking = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.041 2c.594 0 1.072.478 1.072 1.071v.116c0 .237.12.46.317.594l.553.37a2.85 2.85 0 0 1 1.272 2.376v.116c0 .594-.477 1.071-1.071 1.071a1.069 1.069 0 0 1-1.071-1.071v-.116c0-.237-.12-.46-.317-.594l-.554-.37A2.85 2.85 0 0 1 7.97 3.188V3.07C7.97 2.478 8.447 2 9.04 2zm-5.357 8.571c0-.79.638-1.428 1.429-1.428h17.142c.79 0 1.429.638 1.429 1.428a8.57 8.57 0 0 1-5.071 7.826l2.13 4.965a1.07 1.07 0 1 1-1.97.843l-.49-1.134h-7.666A2.855 2.855 0 0 1 5.113 22a2.86 2.86 0 0 1 3.308-2.821l.334-.782a8.57 8.57 0 0 1-5.071-7.826zm6.933 10.358h6.75l-.817-1.907a8.48 8.48 0 0 1-1.437.12h-2.858a8.48 8.48 0 0 1-1.437-.12l-.55 1.282c.144.192.26.401.35.625zM7.97 23.07a1.071 1.071 0 1 0 0-2.142 1.071 1.071 0 0 0 0 2.142zm7.143-20v.116c0 .237.12.46.317.594l.553.37a2.85 2.85 0 0 1 1.272 2.376v.116c0 .594-.477 1.071-1.071 1.071a1.069 1.069 0 0 1-1.071-1.071v-.116c0-.237-.12-.46-.317-.594l-.554-.37a2.85 2.85 0 0 1-1.272-2.375V3.07c0-.593.477-1.071 1.071-1.071s1.072.478 1.072 1.071z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCooking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cooking.b9a50fa0.svg";
export { ForwardRef as ReactComponent };